// Leistungsseiten – zentral bearbeitbar.
export const services = [
  {
    slug: "entruempelung",
    icon: "Truck",
    title: "Entrümpelung",
    h1: "Entrümpelung – professionell und zuverlässig",
    metaTitle: "Entrümpelung | Professionell & zuverlässig | Rümpeltaxi",
    metaDescription:
      "Entrümpelung durch Rümpeltaxi: strukturierte Planung, sorgfältige Durchführung und fachgerechte Entsorgung. Persönlich, diskret und zuverlässig.",
    intro:
      "Ob einzelner Raum oder komplettes Objekt: Bei einer Entrümpelung entfernen wir die vereinbarten Gegenstände sorgfältig, sortieren nach Verwertbarkeit und sorgen für eine fachgerechte Entsorgung. Sie erhalten eine strukturierte Abwicklung aus einer Hand.",
    situations: [
      "Überfüllte Wohnungen oder Häuser",
      "Vorbereitung eines Umzugs oder Verkaufs",
      "Räumung einzelner Zimmer, Keller oder Dachböden",
      "Auflösung nach einem Erbfall",
    ],
    scope: [
      "Sichtung und Abstimmung des Umfangs",
      "Sortierung nach Verwertbarkeit und Entsorgungsweg",
      "Demontage im Zusammenhang mit der Räumung",
      "Abtransport und fachgerechte Entsorgung",
      "Auf Wunsch besenreine Übergabe",
    ],
    process: [
      "Sie schildern uns Ihr Anliegen telefonisch, per WhatsApp oder Formular.",
      "Wir klären Umfang und Zugänglichkeit – anhand von Bildern oder einer Besichtigung.",
      "Sie erhalten ein transparent aufgebautes Angebot.",
      "Nach der Beauftragung stimmen wir Termin und Ablauf ab.",
      "Nach Abschluss prüfen wir das Ergebnis gemeinsam.",
    ],
    extras: [
      "Möbeltransport",
      "Möbelmontage und Demontage",
      "Einlagerung",
      "Entsorgung von Sondermüll nach Vereinbarung",
    ],
    costFactors: [
      "Art und Menge der Gegenstände",
      "Zugänglichkeit des Objekts und Etage",
      "Personal- und Zeitaufwand",
      "Transportwege und Entsorgungskosten",
      "Gewünschte Zusatzleistungen",
    ],
    faq: [
      {
        q: "Übernehmen Sie auch einzelne Räume?",
        a: "Ja. Wir unterstützen sowohl bei kompletten Objekten als auch bei einzelnen Kellern, Dachböden, Garagen oder Zimmern.",
      },
      {
        q: "Was geschieht mit verwertbaren Gegenständen?",
        a: "Ob und wie Gegenstände weiterverwendet, angerechnet, gespendet oder entsorgt werden, wird abhängig von Zustand und Vereinbarung individuell geprüft.",
      },
    ],
    related: ["haushaltsaufloesung", "kellerentruempelung", "entsorgung"],
  },
  {
    slug: "haushaltsaufloesung",
    icon: "Home",
    title: "Haushaltsauflösung",
    h1: "Haushaltsauflösung – strukturiert und respektvoll",
    metaTitle: "Haushaltsauflösung | Strukturiert & diskret | Rümpeltaxi",
    metaDescription:
      "Haushaltsauflösung durch Rümpeltaxi: von der ersten Abstimmung bis zur Übergabe. Respektvoll, diskret und zuverlässig in Ihrer Region.",
    intro:
      "Eine Haushaltsauflösung erfordert Planung, Rücksichtnahme und eine zuverlässige Durchführung. Wir begleiten Sie von der ersten Abstimmung bis zur Übergabe des Objekts – gerade in sensiblen Situationen mit der nötigen Diskretion.",
    situations: [
      "Umzug in eine kleinere Wohnung oder Pflegeeinrichtung",
      "Auflösung nach einem Todesfall",
      "Trennung oder Haushaltszusammenlegung",
      "Vorbereitung eines Immobilienverkaufs",
    ],
    scope: [
      "Vollständige oder teilweise Auflösung des Haushalts",
      "Sortierung persönlicher Gegenstände nach Absprache",
      "Fachgerechte Entsorgung und Abtransport",
      "Demontage von Möbeln bei Bedarf",
      "Auf Wunsch besenreine Übergabe",
    ],
    process: [
      "Kontaktaufnahme und Schilderung Ihres Anliegens.",
      "Klärung von Umfang, Zeitrahmen und besonderen Wünschen.",
      "Transparentes Angebot für die vereinbarten Leistungen.",
      "Terminabstimmung und Durchführung.",
      "Gemeinsame Prüfung und Übergabe.",
    ],
    extras: ["Einlagerung", "Umzug", "Wertermittlung nach Vereinbarung"],
    costFactors: [
      "Größe und Füllgrad des Haushalts",
      "Anteil verwertbarer Gegenstände",
      "Zugänglichkeit und Etage",
      "Entsorgungs- und Transportaufwand",
    ],
    faq: [
      {
        q: "Wie diskret gehen Sie mit persönlichen Dingen um?",
        a: "Der respektvolle und diskrete Umgang mit persönlichen Gegenständen und sensiblen Situationen hat für uns hohe Priorität. Wünsche stimmen wir vorab mit Ihnen ab.",
      },
      {
        q: "Kann ich vorab Bilder senden?",
        a: "Ja. Bilder helfen bei einer ersten Einschätzung. Bei umfangreicheren Projekten kann zusätzlich eine Besichtigung sinnvoll sein.",
      },
    ],
    related: ["nachlassaufloesung", "wohnungsaufloesung", "entruempelung"],
  },
  {
    slug: "wohnungsaufloesung",
    icon: "Building",
    title: "Wohnungsauflösung",
    h1: "Wohnungsauflösung – zügig und sauber",
    metaTitle: "Wohnungsauflösung | Zügig & sauber | Rümpeltaxi",
    metaDescription:
      "Wohnungsauflösung durch Rümpeltaxi – ideal bei Mieterwechsel, Umzug oder Verkauf. Zuverlässige Räumung und auf Wunsch besenreine Übergabe.",
    intro:
      "Bei einer Wohnungsauflösung räumen wir die Wohnung vollständig oder in Teilen, entsorgen fachgerecht und übergeben das Objekt auf Wunsch besenrein – damit Sie sich um den nächsten Schritt kümmern können.",
    situations: [
      "Mieterwechsel und Übergabe an den Vermieter",
      "Umzug in eine andere Wohnung",
      "Verkauf oder Vermietung",
      "Auflösung nach einem Erbfall",
    ],
    scope: [
      "Räumung aller vereinbarten Bereiche",
      "Demontage von Einbauten nach Absprache",
      "Fachgerechte Entsorgung",
      "Auf Wunsch besenreine Übergabe",
    ],
    process: [
      "Anfrage und Beschreibung der Wohnung.",
      "Klärung von Umfang und Termin.",
      "Transparentes Angebot.",
      "Durchführung der Räumung.",
      "Übergabe nach Vereinbarung.",
    ],
    extras: ["Umzug", "Einlagerung", "Kleinreparaturen nach Vereinbarung"],
    costFactors: [
      "Wohnungsgröße und Füllgrad",
      "Etage und Aufzug",
      "Entsorgungsaufwand",
      "Zusatzleistungen",
    ],
    faq: [
      {
        q: "Was bedeutet besenreine Übergabe?",
        a: "Besenrein bedeutet in der Regel, dass die vereinbarten Gegenstände entfernt und die geräumten Flächen grob ausgekehrt übergeben werden. Weitergehende Reinigung wird gesondert vereinbart.",
      },
    ],
    related: ["haushaltsaufloesung", "entruempelung", "umzug"],
  },
  {
    slug: "nachlassaufloesung",
    icon: "HeartHandshake",
    title: "Nachlassauflösung",
    h1: "Nachlassauflösung – einfühlsam und verlässlich",
    metaTitle: "Nachlassauflösung | Einfühlsam & verlässlich | Rümpeltaxi",
    metaDescription:
      "Nachlassauflösung durch Rümpeltaxi: respektvolle, diskrete Abwicklung nach einem Todesfall. Wir entlasten Angehörige und Erben.",
    intro:
      "Die Auflösung eines Nachlasses ist oft mit einer emotionalen Ausnahmesituation verbunden. Wir arbeiten respektvoll, diskret und verlässlich und entlasten Angehörige, Erben und Erbengemeinschaften bei der Räumung.",
    situations: [
      "Todesfall in der Familie",
      "Erbschaft und Erbengemeinschaften",
      "Vorbereitung einer Immobilienübergabe",
      "Betreuungs- oder Nachlasspflegesituationen",
    ],
    scope: [
      "Sichtung und Sortierung persönlicher Gegenstände",
      "Sichern von Dokumenten und Wertgegenständen nach Absprache",
      "Fachgerechte Entsorgung und Abtransport",
      "Auf Wunsch besenreine Übergabe",
    ],
    process: [
      "Vertrauliche Kontaktaufnahme.",
      "Abstimmung von Umfang und Wünschen.",
      "Transparentes Angebot.",
      "Sorgfältige Durchführung.",
      "Übergabe des Objekts.",
    ],
    extras: ["Einlagerung", "Wertermittlung nach Vereinbarung"],
    costFactors: [
      "Umfang des Nachlasses",
      "Anteil verwertbarer Gegenstände",
      "Zugänglichkeit",
      "Entsorgungsaufwand",
    ],
    faq: [
      {
        q: "Arbeiten Sie auch mit Nachlasspflegern und Betreuern zusammen?",
        a: "Ja. Wir bearbeiten Anfragen von Angehörigen ebenso wie von gesetzlichen Betreuern, Nachlasspflegern, Kanzleien und Hausverwaltungen.",
      },
    ],
    related: ["haushaltsaufloesung", "wohnungsaufloesung", "entruempelung"],
  },
  {
    slug: "gewerbeaufloesung",
    icon: "Briefcase",
    title: "Gewerbeauflösung",
    h1: "Gewerbeauflösung – planbar für Unternehmen",
    metaTitle: "Gewerbeauflösung | Büro, Praxis & Lager | Rümpeltaxi",
    metaDescription:
      "Gewerbeauflösung durch Rümpeltaxi: Büro-, Praxis- und Lagerräumungen mit planbarer Terminierung und fachgerechter Entsorgung.",
    intro:
      "Für Unternehmen, Praxen und Institutionen übernehmen wir umfangreiche Räumungs-, Transport- und Entsorgungsprojekte mit planbarer Terminierung und klarer Abstimmung – auch mehrstufig.",
    situations: [
      "Büro- oder Praxisauflösung",
      "Geschäfts- oder Standortschließung",
      "Lager- und Hallenräumung",
      "Firmenaufgabe oder Insolvenz",
    ],
    scope: [
      "Räumung von Büros, Praxen, Lagern und Hallen",
      "Demontage von Mobiliar und Einbauten",
      "Fachgerechte Entsorgung",
      "Abgestimmte Projekt- und Terminplanung",
    ],
    process: [
      "Anfrage über das Geschäftskundenformular.",
      "Objektbegehung und Umfangsklärung.",
      "Angebot und Terminplanung.",
      "Durchführung, ggf. mehrstufig.",
      "Übergabe nach Vereinbarung.",
    ],
    extras: ["Möbeltransport", "Einlagerung", "Demontage"],
    costFactors: [
      "Fläche und Ausstattung",
      "Menge und Art der Gegenstände",
      "Terminliche Anforderungen",
      "Entsorgungs- und Transportaufwand",
    ],
    faq: [
      {
        q: "Räumen Sie auch kurzfristig für Hausverwaltungen?",
        a: "Dringende Anfragen prüfen wir individuell. Die Verfügbarkeit hängt von Umfang, Einsatzort und Auslastung ab.",
      },
    ],
    related: ["entsorgung", "umzug", "einlagerung"],
  },
  {
    slug: "kellerentruempelung",
    icon: "PackageOpen",
    title: "Kellerentrümpelung",
    h1: "Kellerentrümpelung – schnell wieder Platz",
    metaTitle: "Kellerentrümpelung | Schnell & sauber | Rümpeltaxi",
    metaDescription:
      "Kellerentrümpelung durch Rümpeltaxi: sicheres Räumen enger Kellerräume, fachgerechte Entsorgung und saubere Übergabe.",
    intro:
      "Volle Kellerabteile lassen sich oft schwer selbst räumen. Wir entrümpeln Ihren Keller sicher, sortieren nach Verwertbarkeit und sorgen für eine fachgerechte Entsorgung.",
    situations: [
      "Überfüllte Kellerabteile",
      "Feuchte oder schwer zugängliche Räume",
      "Vorbereitung eines Umzugs",
      "Auflösung von Gemeinschaftskellern",
    ],
    scope: [
      "Räumung des Kellers oder einzelner Abteile",
      "Transport über enge Wege und Treppen",
      "Fachgerechte Entsorgung",
      "Auf Wunsch besenreine Übergabe",
    ],
    process: [
      "Anfrage mit kurzer Beschreibung.",
      "Klärung von Zugang und Umfang.",
      "Angebot.",
      "Durchführung.",
      "Übergabe.",
    ],
    extras: ["Entsorgung", "Sperrmüllentsorgung"],
    costFactors: ["Menge der Gegenstände", "Zugänglichkeit", "Transportwege", "Entsorgungsaufwand"],
    faq: [
      {
        q: "Räumen Sie auch schwer zugängliche Keller?",
        a: "Ja. Enge Treppen und Wege gehören zu unserem Arbeitsalltag. Details klären wir vorab.",
      },
    ],
    related: ["dachbodenentruempelung", "entruempelung", "entsorgung"],
  },
  {
    slug: "dachbodenentruempelung",
    icon: "Warehouse",
    title: "Dachbodenentrümpelung",
    h1: "Dachbodenentrümpelung – sicher geräumt",
    metaTitle: "Dachbodenentrümpelung | Sicher & sauber | Rümpeltaxi",
    metaDescription:
      "Dachbodenentrümpelung durch Rümpeltaxi: sicheres Räumen unter beengten Verhältnissen und fachgerechte Entsorgung.",
    intro:
      "Dachböden sind häufig über Jahre gewachsene Lager. Wir räumen sicher, auch unter beengten Verhältnissen, und entsorgen fachgerecht.",
    situations: [
      "Über Jahre gefüllte Dachböden",
      "Vorbereitung von Umbau oder Verkauf",
      "Auflösung nach einem Erbfall",
      "Beengte oder niedrige Räume",
    ],
    scope: [
      "Räumung des Dachbodens",
      "Sicherer Transport über Treppen",
      "Fachgerechte Entsorgung",
      "Auf Wunsch besenreine Übergabe",
    ],
    process: ["Anfrage.", "Umfangsklärung.", "Angebot.", "Durchführung.", "Übergabe."],
    extras: ["Entsorgung", "Demontage"],
    costFactors: ["Menge", "Zugänglichkeit", "Transportaufwand", "Entsorgungskosten"],
    faq: [
      {
        q: "Auch bei sehr niedrigen Dachböden möglich?",
        a: "Ja. Wir arbeiten routiniert unter beengten Bedingungen. Besonderheiten stimmen wir vorab ab.",
      },
    ],
    related: ["kellerentruempelung", "entruempelung", "entsorgung"],
  },
  {
    slug: "messie-wohnung",
    icon: "ShieldCheck",
    title: "Messie-Wohnung räumen",
    h1: "Räumung stark überfüllter Objekte – diskret",
    metaTitle: "Messie-Wohnung räumen | Diskret & respektvoll | Rümpeltaxi",
    metaDescription:
      "Diskrete Räumung stark überfüllter Objekte durch Rümpeltaxi. Respektvoll, sachlich und ohne Vorurteile.",
    intro:
      "Stark überfüllte Objekte erfordern besonderes Fingerspitzengefühl. Wir gehen respektvoll, diskret und ohne Vorurteile vor und stimmen jeden Schritt persönlich mit Ihnen ab.",
    situations: [
      "Stark überfüllte Wohnungen",
      "Sensible Betreuungssituationen",
      "Zusammenarbeit mit Betreuern und sozialen Einrichtungen",
      "Vorbereitung einer Sanierung",
    ],
    scope: [
      "Diskrete und schrittweise Räumung",
      "Sortierung nach Vorgaben",
      "Fachgerechte Entsorgung",
      "Auf Wunsch besenreine Übergabe",
    ],
    process: [
      "Vertrauliche Kontaktaufnahme.",
      "Behutsame Abstimmung des Vorgehens.",
      "Angebot.",
      "Schrittweise Durchführung.",
      "Übergabe.",
    ],
    extras: ["Entsorgung", "Grundlegende Räumung vor Reinigung"],
    costFactors: ["Füllgrad", "Zustand des Objekts", "Aufwand", "Entsorgungskosten"],
    faq: [
      {
        q: "Wie diskret arbeiten Sie?",
        a: "Diskretion ist in diesen Situationen zentral. Wir vermeiden Aufsehen und stimmen den Ablauf eng mit Ihnen und ggf. beteiligten Stellen ab.",
      },
    ],
    related: ["haushaltsaufloesung", "entruempelung", "entsorgung"],
  },
  {
    slug: "entsorgung",
    icon: "Recycle",
    title: "Entsorgung",
    h1: "Entsorgung – fachgerecht und sauber",
    metaTitle: "Entsorgung & Sperrmüll | Fachgerecht | Rümpeltaxi",
    metaDescription:
      "Fachgerechte Entsorgung und Sperrmüllentsorgung durch Rümpeltaxi: Möbel, Sperrmüll und mehr – sauber abtransportiert.",
    intro:
      "Wir entsorgen Möbel, Sperrmüll und weitere Gegenstände fachgerecht und sauber. Verwertbares wird nach Möglichkeit getrennt und einer sinnvollen Weiterverwendung zugeführt.",
    situations: [
      "Möbel- und Sperrmüllentsorgung",
      "Entsorgung nach einer Räumung",
      "Einzelne größere Gegenstände",
      "Gewerbliche Entsorgungsmengen",
    ],
    scope: [
      "Abtransport der vereinbarten Gegenstände",
      "Trennung nach Verwertbarkeit",
      "Fachgerechte Entsorgung",
      "Entsorgung von Sondermüll nach Vereinbarung",
    ],
    process: ["Anfrage.", "Mengenklärung.", "Angebot.", "Abholung.", "Fachgerechte Entsorgung."],
    extras: ["Demontage", "Möbeltransport"],
    costFactors: ["Menge und Art", "Sondermüllanteil", "Transportwege", "Entsorgungsgebühren"],
    faq: [
      {
        q: "Welche Gegenstände gelten als Sondermüll?",
        a: "Dazu zählen unter anderem bestimmte Elektrogeräte, Farben, Chemikalien und weitere Stoffe. Diese werden gesondert behandelt und abgerechnet.",
      },
    ],
    related: ["entruempelung", "kellerentruempelung", "gewerbeaufloesung"],
  },
  {
    slug: "umzug",
    icon: "Container",
    title: "Umzug",
    h1: "Umzug – zuverlässig transportiert",
    metaTitle: "Umzug & Möbeltransport | Zuverlässig | Rümpeltaxi",
    metaDescription:
      "Umzug und Möbeltransport durch Rümpeltaxi: sorgfältiger Transport Ihrer Möbel und Gegenstände – auf Wunsch mit Montage.",
    intro:
      "Wir transportieren Ihre Möbel und Gegenstände zuverlässig und sorgfältig – vom einzelnen Möbelstück bis zum kompletten Umzug, auf Wunsch inklusive Montage.",
    situations: [
      "Privater Wohnungsumzug",
      "Einzelne Möbeltransporte",
      "Umzug in eine Pflegeeinrichtung",
      "Gewerbliche Umzüge",
    ],
    scope: [
      "Verpackung nach Vereinbarung",
      "Sorgfältiger Transport",
      "Be- und Entladung",
      "Auf Wunsch Möbelmontage",
    ],
    process: ["Anfrage.", "Umfangsklärung.", "Angebot.", "Durchführung.", "Übergabe."],
    extras: ["Möbelmontage", "Einlagerung", "Entrümpelung der alten Wohnung"],
    costFactors: ["Transportvolumen", "Entfernung", "Etagen und Aufzug", "Zusatzleistungen"],
    faq: [
      {
        q: "Übernehmen Sie auch die Räumung der alten Wohnung?",
        a: "Ja. Umzug und Entrümpelung lassen sich sinnvoll kombinieren. Details klären wir im Angebot.",
      },
    ],
    related: ["moebelmontage", "einlagerung", "wohnungsaufloesung"],
  },
  {
    slug: "moebelmontage",
    icon: "Wrench",
    title: "Möbelmontage",
    h1: "Möbelmontage und Demontage – fachgerecht",
    metaTitle: "Möbelmontage & Demontage | Fachgerecht | Rümpeltaxi",
    metaDescription:
      "Möbelmontage und Demontage durch Rümpeltaxi: fachgerechter Auf- und Abbau Ihrer Möbel – im Rahmen von Umzug oder Räumung.",
    intro:
      "Wir montieren und demontieren Möbel fachgerecht – als eigenständige Leistung oder im Rahmen eines Umzugs bzw. einer Räumung.",
    situations: [
      "Auf- und Abbau bei einem Umzug",
      "Demontage vor einer Räumung",
      "Montage neuer Möbel",
      "Küchen- und Schrankmontage nach Vereinbarung",
    ],
    scope: [
      "Fachgerechte Demontage",
      "Sicherer Transport der Teile",
      "Montage am Zielort",
      "Entsorgung nicht mehr benötigter Möbel",
    ],
    process: ["Anfrage.", "Umfangsklärung.", "Angebot.", "Durchführung.", "Abnahme."],
    extras: ["Umzug", "Entsorgung"],
    costFactors: ["Anzahl und Art der Möbel", "Aufwand", "Anfahrt"],
    faq: [
      {
        q: "Montieren Sie auch einzelne Möbelstücke?",
        a: "Ja. Wir übernehmen einzelne Montagen ebenso wie umfangreichere Projekte.",
      },
    ],
    related: ["umzug", "einlagerung", "entsorgung"],
  },
  {
    slug: "einlagerung",
    icon: "Boxes",
    title: "Einlagerung",
    h1: "Einlagerung – sicher zwischengelagert",
    metaTitle: "Einlagerung | Sicher zwischenlagern | Rümpeltaxi",
    metaDescription:
      "Einlagerung durch Rümpeltaxi: sichere Zwischenlagerung Ihrer Möbel und Gegenstände nach Vereinbarung.",
    intro:
      "Wenn Möbel und Gegenstände vorübergehend nicht untergebracht werden können, bieten wir eine Einlagerung nach Vereinbarung – als sinnvolle Ergänzung zu Umzug oder Räumung.",
    situations: [
      "Überbrückung zwischen zwei Umzügen",
      "Zwischenlagerung während einer Sanierung",
      "Aufbewahrung ausgewählter Gegenstände",
      "Flexibler Lagerbedarf",
    ],
    scope: [
      "Abholung und Transport",
      "Sichere Einlagerung nach Vereinbarung",
      "Rücktransport bei Bedarf",
    ],
    process: ["Anfrage.", "Bedarfsklärung.", "Angebot.", "Abholung und Einlagerung.", "Rückgabe nach Absprache."],
    extras: ["Umzug", "Möbelmontage"],
    costFactors: ["Volumen", "Dauer der Lagerung", "Transportaufwand"],
    faq: [
      {
        q: "Wie lange kann eingelagert werden?",
        a: "Die Dauer richtet sich nach Ihrem Bedarf und wird individuell vereinbart.",
      },
    ],
    related: ["umzug", "moebelmontage", "haushaltsaufloesung"],
  },
  {
    slug: "transport",
    icon: "PackageOpen",
    title: "Transport",
    h1: "Transport – Möbel, Geräte und Material sicher von A nach B",
    metaTitle: "Transport Ulm, Neu-Ulm & Illertissen | Möbeltransport | Rümpeltaxi",
    metaDescription:
      "Transporte in Ulm, Neu-Ulm, Illertissen und Altenstadt: Möbel, Haushaltsgeräte, Baumaterial oder Einzelstücke – mit Transporter und Sorgfalt. Rümpeltaxi, Tel. 0151 70004440.",
    intro:
      "Nicht alles, was bewegt werden muss, ist ein kompletter Umzug. Oft geht es um ein Sofa vom Möbelhaus, eine Waschmaschine zur Tochter nach Neu-Ulm, Baumaterial zur Baustelle oder ein Erbstück, das nach Illertissen soll. Genau dafür ist unser Transporter da.",
    body: [
      "Wir fahren mit einem hohen Kastenwagen, der auch lange Sofas, Schränke, Matratzen oder Paletten aufnimmt, und kommen auf Wunsch mit zwei Personen, damit schwere Stücke sicher durch Treppenhaus und Tür kommen. Decken, Spanngurte und Rollbretter gehören zur Ausrüstung, Kanten und Böden werden geschützt. Wo nötig, demontieren wir vorher und bauen am Ziel wieder auf.",
      "Unser Kernraum sind Ulm, Neu-Ulm, Illertissen und unser Sitz Altenstadt an der Iller – hier sind wir am schnellsten und können auch kurze Strecken wirtschaftlich anbieten. Längere Fahrten in die Region oder über sie hinaus stimmen wir individuell ab. Für Händler und Handwerksbetriebe übernehmen wir auch regelmäßige Auslieferungen oder Abholungen.",
      "Typische Fälle: Abholung von Möbeln aus Kleinanzeigen oder vom Möbelhaus, Transport einzelner Geräte in ein Pflegeheim, Umlagerung von Büromöbeln zwischen zwei Standorten, Materialtransport für Sanierungen oder das Bringen von Sperrigem zum Wertstoffhof. Sie nennen uns Abhol- und Zielort, Etagen und was transportiert wird – wir nennen Ihnen einen Termin und ein klares Angebot.",
    ],
    situations: [
      "Möbelabholung aus Kleinanzeigen oder Möbelhaus",
      "Einzelnes Gerät oder Möbelstück zu Angehörigen",
      "Material- und Werkzeugtransport zur Baustelle",
      "Fahrt zum Wertstoffhof mit Sperrigem",
    ],
    scope: [
      "Abholung, Verladung und sichere Ladungssicherung",
      "Auf Wunsch zwei Personen für schwere Stücke",
      "Demontage und Wiederaufbau nach Vereinbarung",
      "Lieferung bis in die gewünschte Etage",
    ],
    process: [
      "Sie nennen uns Abholort, Zielort und die Gegenstände.",
      "Wir klären Etagen, Zugang und Zeitfenster.",
      "Sie erhalten ein Angebot für die Fahrt.",
      "Abholung und Transport zum vereinbarten Termin.",
      "Übergabe am Zielort – auf Wunsch mit Aufbau.",
    ],
    extras: ["Möbelmontage", "Einlagerung", "Entsorgung nicht mehr benötigter Teile"],
    costFactors: ["Strecke und Fahrzeit", "Anzahl und Gewicht der Gegenstände", "Etagen und Aufzug", "Personenzahl"],
    faq: [
      {
        q: "Transportieren Sie auch nur ein einzelnes Möbelstück?",
        a: "Ja. Gerade im Raum Ulm, Neu-Ulm, Illertissen und Altenstadt lohnen sich auch kleine Fahrten – wir verbinden sie oft mit anderen Terminen in der Nähe.",
      },
      {
        q: "Kommen Sie mit zwei Personen?",
        a: "Wenn es nötig ist, ja. Bei schweren oder sperrigen Stücken planen wir zwei Personen ein, damit nichts beschädigt wird.",
      },
    ],
    related: ["umzug", "moebelmontage", "einlagerung"],
  },
  {
    slug: "abriss",
    icon: "Hammer",
    title: "Abriss",
    h1: "Abriss und Rückbau – Nebengebäude, Einbauten und Kleinabbrüche",
    metaTitle: "Abriss & Rückbau Ulm, Neu-Ulm, Illertissen | Rümpeltaxi Altenstadt",
    metaDescription:
      "Kleinabbruch und Rückbau in Ulm, Neu-Ulm, Illertissen und Altenstadt: Gartenhäuser, Schuppen, Garagen, Einbauküchen, Trennwände – inklusive Entsorgung. Tel. 0151 70004440.",
    intro:
      "Manchmal reicht Ausräumen nicht: Das alte Gartenhaus muss weg, die Einbauküche raus, der Schuppen soll Platz für einen Carport machen. Wir übernehmen Kleinabbrüche und Rückbauten innerhalb von Gebäuden – ordentlich, mit Sortierung des Bauschutts und fachgerechter Entsorgung.",
    body: [
      "Zu unseren Abrissarbeiten gehören der Rückbau von Gartenhäusern, Holz- und Blechschuppen, Carports, kleinen Garagen, Zäunen und Terrassenbelägen sowie im Innenbereich das Entfernen von Einbauküchen, Einbauschränken, Leichtbauwänden, Deckenverkleidungen, Teppich-, Laminat- oder Fliesenböden. Wir arbeiten mit Handwerkzeug und kleinen Elektrogeräten – für ganze Häuser oder tragende Bauteile sind wir nicht der richtige Partner und sagen das offen.",
      "Der Bauschutt wird direkt beim Abbau getrennt: Holz, Metall, mineralischer Schutt, Dämmstoffe und Restmüll landen in unterschiedlichen Fraktionen und werden über die zugelassenen Entsorger in Ulm, im Landkreis Neu-Ulm und im Alb-Donau-Kreis abgegeben. Bei Verdacht auf asbesthaltige Platten oder andere Schadstoffe klären wir vorab die richtige Vorgehensweise und ziehen bei Bedarf einen Fachbetrieb hinzu.",
      "Wir sind in Ulm, Neu-Ulm, Illertissen und rund um unseren Sitz in Altenstadt regelmäßig im Einsatz und kombinieren Abriss häufig mit einer Entrümpelung: erst wird das Gebäude leergeräumt, dann zurückgebaut, am Ende ist die Fläche frei und sauber. Für Eigentümer, die ein Grundstück verkaufen oder neu gestalten möchten, ist das ein Termin statt drei.",
    ],
    situations: [
      "Gartenhaus, Schuppen oder Carport entfernen",
      "Einbauküche oder Einbauschränke vor der Renovierung ausbauen",
      "Trennwände, Verkleidungen und Böden zurückbauen",
      "Grundstück vor Verkauf oder Neugestaltung freimachen",
    ],
    scope: [
      "Besichtigung und Einschätzung, was rückgebaut werden kann",
      "Rückbau mit Hand- und Elektrowerkzeug",
      "Sortenreine Trennung des Bauschutts",
      "Abtransport und Entsorgung über zugelassene Entsorger",
      "Grobreinigung der Fläche",
    ],
    process: [
      "Sie beschreiben uns das Objekt, gerne mit Fotos.",
      "Wir besichtigen vor Ort und prüfen Umfang und Schadstoffe.",
      "Sie erhalten ein Angebot inklusive Entsorgung.",
      "Rückbau zum vereinbarten Termin.",
      "Übergabe der freien, sauberen Fläche.",
    ],
    extras: ["Entrümpelung vor dem Abriss", "Transport von Baumaterial", "Galabau nach dem Rückbau"],
    costFactors: ["Größe und Bauweise", "Materialmix und Entsorgungsfraktionen", "Zugang für Fahrzeug und Container", "Schadstoffverdacht"],
    faq: [
      {
        q: "Reißen Sie auch ganze Häuser ab?",
        a: "Nein. Wir übernehmen Kleinabbrüche wie Gartenhäuser, Schuppen, Garagen und den Rückbau von Einbauten. Für Gebäudeabbrüche mit Statik und Genehmigung vermitteln wir gerne.",
      },
      {
        q: "Was passiert mit dem Bauschutt?",
        a: "Er wird getrennt und über zugelassene Entsorger in Ulm, im Landkreis Neu-Ulm und im Alb-Donau-Kreis entsorgt. Die Entsorgung ist im Angebot enthalten.",
      },
    ],
    related: ["entruempelung", "entsorgung", "galabau"],
  },
  {
    slug: "galabau",
    icon: "Shovel",
    title: "Galabau",
    h1: "Galabau im Raum Ulm, Neu-Ulm und Altenstadt",
    metaTitle: "Galabau Ulm & Neu-Ulm | Garten- und Landschaftsbau | Rümpeltaxi",
    metaDescription:
      "Garten- und Landschaftsbau aus Altenstadt bei Ulm. Pflaster, Beete, Grünflächen in Neu-Ulm, Senden, Illertissen, Dornstadt, Blaustein. 0151 70004440.",
    image: "van",
    intro:
      "Garten- und Landschaftsbau von Rümpeltaxi: Wir legen Wege und Pflasterflächen an, bereiten Pflanzflächen und Rasen vor, übernehmen Erd- und Planierarbeiten nach einer Räumung oder einem Abriss und entsorgen Grünschnitt und Schutt. Persönlich geführt von Thomas Dietrich aus Altenstadt an der Iller – für Ulm, Neu-Ulm und die Region.",
    body: [
      "Viele unserer Galabau-Aufträge beginnen dort, wo eine Entrümpelung oder ein Rückbau endet. Das Gartenhaus ist weg, der alte Schuppen abgebaut, der Garten eines Elternhauses in Senden oder Vöhringen seit Jahren sich selbst überlassen. Wir räumen den Außenbereich, roden Wildwuchs und Wurzelstöcke, tragen alte Platten, Kies oder Rindenmulch ab und bringen die Fläche mit Erd- und Planierarbeiten auf ein sauberes Niveau. Erst dann entsteht Neues.",
      "Pflaster und Wege: Wir bauen Gartenwege, Terrassen, Stellplätze und Zufahrten aus Betonpflaster, Naturstein oder Platten – vom Aushub über die Tragschicht bis zur Verlegung, den Randsteinen und dem Verfugen. In Ulm und Neu-Ulm sind das häufig Reihenhausgärten und Vorgärten mit begrenztem Zugang, in Dornstadt, Blaustein oder Beimerstetten eher größere Grundstücke mit Einfahrt und Hofbereich. Wir planen den Materialtransport entsprechend und arbeiten so, dass Nachbarn und Zufahrten möglichst wenig belastet werden.",
      "Pflanzflächen und Rasen: Beete werden ausgehoben, mit Pflanzerde aufgefüllt und mit Rasenkante oder Stahlkante eingefasst; auf Wunsch setzen wir Hecken, Sträucher und Bodendecker oder legen Kies- und Splittflächen mit Unkrautvlies an. Für Rasen bereiten wir den Boden vor, planieren, walzen und säen ein oder verlegen Rollrasen – so, dass die Fläche gleichmäßig und pflegeleicht wird. In Blaubeuren und Blaustein am Rand der Alb ist der Boden oft steinig, hier bringen wir bei Bedarf zusätzlich Oberboden ein.",
      "Entsorgung gehört bei uns dazu: Grünschnitt, Wurzeln, Erdaushub, alter Beton und Pflasterschutt werden getrennt geladen und über die zugelassenen Annahmestellen in Ulm, im Landkreis Neu-Ulm und im Alb-Donau-Kreis entsorgt. Sie müssen keinen Container bestellen und nichts selbst zum Wertstoffhof fahren. Wenn brauchbare Pflanzen, Platten oder Gartenmöbel übrig bleiben, transportieren wir sie auf Wunsch zu Ihnen oder zu Angehörigen.",
      "Unser Kernraum für Galabau reicht von Altenstadt und Illertissen über Weißenhorn, Vöhringen und Senden bis nach Neu-Ulm und Ulm sowie in die nördlichen Gemeinden Dornstadt, Beimerstetten, Blaustein und Blaubeuren. Wir besichtigen vor Ort, besprechen Aufteilung, Materialien und Reihenfolge und nennen einen Zeitrahmen. Stützmauern mit Statik oder Teichanlagen gehören nicht zu unserem Angebot – dafür vermitteln wir an Fachbetriebe. Wege, Beete, Rasen und Flächenvorbereitung erledigen wir aus einer Hand.",
    ],
    situations: [
      "Garten nach Entrümpelung oder Abriss neu anlegen",
      "Gartenweg, Terrasse oder Stellplatz pflastern",
      "Beete, Hecken und Rasen neu anlegen",
      "Grundstück vor Verkauf oder Vermietung herrichten",
    ],
    scope: [
      "Erd- und Planierarbeiten, Aushub und Oberboden",
      "Pflaster- und Plattenarbeiten inkl. Tragschicht und Randsteine",
      "Pflanzflächen, Hecken, Kies- und Splittflächen",
      "Rasenneuanlage durch Aussaat oder Rollrasen",
      "Entsorgung von Grünschnitt, Aushub und Schutt",
    ],
    process: [
      "Sie schicken uns Fotos oder eine kurze Skizze der Fläche.",
      "Wir besichtigen vor Ort und besprechen Materialien und Aufteilung.",
      "Sie erhalten ein Angebot inklusive Entsorgung.",
      "Erd-, Pflaster- und Pflanzarbeiten zum vereinbarten Termin.",
      "Übergabe der fertigen Fläche.",
    ],
    extras: ["Entrümpelung von Haus und Keller", "Abriss von Gartenhaus oder Schuppen", "Transport von Pflanzen, Platten oder Gartenmöbeln"],
    costFactors: ["Fläche und Bodenbeschaffenheit", "Material (Pflaster, Erde, Pflanzen)", "Menge an Aushub und Grünschnitt", "Zugang für Fahrzeug und Material"],
    faq: [
      {
        q: "Pflastern Sie auch in Blaustein, obwohl Sie in Altenstadt sitzen?",
        a: "Ja. Blaustein liegt in unserem Einsatzraum nördlich von Ulm. Wir besichtigen vor Ort, planen den Materialtransport und führen Aushub, Tragschicht und Verlegung aus einer Hand aus.",
      },
      {
        q: "Legen Sie in Beimerstetten auch Rasen und Beete neu an?",
        a: "Ja. In Beimerstetten und den Nachbargemeinden bereiten wir den Boden vor, planieren, säen oder verlegen Rollrasen und legen Beete mit Einfassung an.",
      },
      {
        q: "Kann der Garten in Senden zusammen mit dem Haus geräumt werden?",
        a: "Ja. In Senden, Vöhringen und Neu-Ulm kombinieren wir das regelmäßig: erst Entrümpelung und Rückbau, dann Planierung und Neuanlage – ein Ansprechpartner für innen und außen.",
      },
    ],
    related: ["abriss", "entruempelung", "transport"],
  },
];

export const getService = (slug) => services.find((s) => s.slug === slug);
